// extracted by mini-css-extract-plugin
module.exports = {"avatar-container":"ProfileIcon_avatar-container__205aW","initial-placeholder":"ProfileIcon_initial-placeholder__vhuSC"};